module.exports = __webpack_public_path__ + "style/img/Group 1896.959b6b54.png";